module.exports = __webpack_public_path__ + "static/media/phoneActive.8764ffa9.svg";